var _path, _rect, _ellipse, _ellipse2, _path2, _ellipse3, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _mask, _path4, _mask2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudFunctionsOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 317,
    viewBox: "0 0 306 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.871 52.2288C208.112 52.1894 215.759 56.5156 219.97 63.6001L244.352 104.622L268.41 145.835C272.565 152.953 272.641 161.738 268.611 168.927L245.277 210.554L221.614 251.995C217.527 259.152 209.957 263.611 201.716 263.715L153.999 264.32L106.279 264.548C98.0374 264.587 90.3909 260.261 86.18 253.177L61.7976 212.155L37.7399 170.942C33.5851 163.824 33.5084 155.039 37.5384 147.85L60.8731 106.223L84.5359 64.7821C88.6225 57.6251 96.1924 53.1661 104.433 53.0616L152.15 52.4568L199.871 52.2288Z",
    fill: "#4684EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.856,
    y: 112.134,
    width: 146.273,
    height: 66.7033,
    transform: "rotate(44.6058 117.856 112.134)",
    fill: "#3D7CE3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.098,
    cy: 158.263,
    rx: 6.56303,
    ry: 6.75054,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.85,
    cy: 158.263,
    rx: 6.56303,
    ry: 6.75054,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.539 153.012L193.165 167.451L183.317 177.441L170.664 164.405L178.539 153.012Z",
    fill: "#3D7CE3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.601,
    cy: 158.263,
    rx: 6.56303,
    ry: 6.75054,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.792 130.51L261.796 180.765L220.918 253.145L158.086 216.604L207.792 130.51Z",
    fill: "#3D7CE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195.635,
    y: 130.577,
    width: 12.001,
    height: 55.1294,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.193,
    y: 120.245,
    width: 12.001,
    height: 26.6032,
    transform: "rotate(-45 180.193 120.245)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 199.004,
    y: 177.081,
    width: 12.001,
    height: 26.6646,
    transform: "rotate(45 199.004 177.081)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.284,
    y: 185.604,
    width: 12.001,
    height: 55.1294,
    transform: "rotate(180 110.284 185.604)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.726,
    y: 195.935,
    width: 12.001,
    height: 26.6032,
    transform: "rotate(135 125.726 195.935)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.915,
    y: 139.1,
    width: 12.001,
    height: 26.6646,
    transform: "rotate(-135 106.915 139.1)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9056,
    y: 124.885,
    width: 27.3772,
    height: 62.255,
    fill: "#4684EB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_3754_20684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.164 262.346L197.666 239.644L220.918 253.042L218.668 256.206L215.48 258.997L213.605 260.3L210.979 261.416L206.854 262.905L203.479 263.463L176.852 264.021L175.164 262.346Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.666 239.644L217.326 205.525L191.048 190.383L169.698 211.923L197.666 239.644ZM175.164 262.346L147.196 234.626L119.492 262.577L147.426 290.298L175.164 262.346ZM176.852 264.021L149.114 291.972L160.973 303.741L177.677 303.391L176.852 264.021ZM203.479 263.463L204.304 302.833L207.123 302.773L209.904 302.313L203.479 263.463ZM206.854 262.905L213.28 301.755L216.833 301.167L220.22 299.945L206.854 262.905ZM210.979 261.416L224.346 298.456L225.38 298.083L226.391 297.653L210.979 261.416ZM213.605 260.3L229.016 296.537L232.744 294.951L236.07 292.64L213.605 260.3ZM215.48 258.997L237.946 291.338L239.759 290.078L241.421 288.623L215.48 258.997ZM218.668 256.206L244.609 285.832L248.081 282.791L250.756 279.031L218.668 256.206ZM220.918 253.042L253.006 275.867L278.123 240.557L240.578 218.923L220.918 253.042ZM169.698 211.923L147.196 234.626L203.132 290.067L225.634 267.365L169.698 211.923ZM147.426 290.298L149.114 291.972L204.589 236.07L202.902 234.395L147.426 290.298ZM177.677 303.391L204.304 302.833L202.653 224.093L176.026 224.652L177.677 303.391ZM209.904 302.313L213.28 301.755L200.428 224.054L197.053 224.613L209.904 302.313ZM220.22 299.945L224.346 298.456L197.613 224.376L193.488 225.864L220.22 299.945ZM226.391 297.653L229.016 296.537L198.193 224.063L195.568 225.179L226.391 297.653ZM236.07 292.64L237.946 291.338L193.014 226.656L191.139 227.959L236.07 292.64ZM241.421 288.623L244.609 285.832L192.727 226.58L189.539 229.371L241.421 288.623ZM250.756 279.031L253.006 275.867L188.829 230.217L186.579 233.381L250.756 279.031ZM240.578 218.923L217.326 205.525L178.006 273.764L201.258 287.162L240.578 218.923Z",
    fill: "#3D7CE3",
    mask: "url(#path-15-inside-1_3754_20684)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-2_3754_20684",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.603 169.889L188.853 163.138L195.603 150.387V169.889Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.853 163.138L170.955 153.663L163.956 166.882L174.533 177.458L188.853 163.138ZM195.603 169.889L181.283 184.209L215.855 218.78V169.889H195.603ZM195.603 150.387H215.855L177.705 140.912L195.603 150.387ZM174.533 177.458L181.283 184.209L209.923 155.569L203.173 148.818L174.533 177.458ZM215.855 169.889V150.387H175.352V169.889H215.855ZM177.705 140.912L170.955 153.663L206.751 172.614L213.501 159.863L177.705 140.912Z",
    fill: "#4684EB",
    mask: "url(#path-17-inside-2_3754_20684)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFunctionsOn);
export default __webpack_public_path__ + "static/media/cloud-functions-on.5e1fade9359e1af78b74f6aa9174a279.svg";
export { ForwardRef as ReactComponent };